import React, { useEffect, useState } from "react";
import moment from 'moment'
import './MobileTimesCompNew.scss';
import SVGInline from 'react-svg-inline'
import ArrowLeft from '../../../shared/assets/left.svg';
import ArrowRight from '../../../shared/assets/right.svg';
import arrowUp from "../../../shared/assets/arrow-up.svg";
import arrowDown from "../../../shared/assets/arrow-down.svg";
import MobileTimesCompShimUI from "./MobileTimesCompShimUI.jsx";

const MobileTimesCompNew = ({ data, getTimesDataOnScroll, selectedLocation, isLoadingNewLocation, onProviderTimeClick, provider }) => {
  
    const [responseData, setResponseData] = useState(data)
    const [currentMonth, setCurrentMonth] = useState(new Date())
    const [timeslotData, setTimesSlotData] = useState({})
    const [selectedDate, setSelectedDate] = useState(null)
    const [expanded, setExpanded] = useState(false)
    const [fetchingData, setFetchingData] = useState(true)
    const [daysInMonth, setDaysInMonth] = useState(null)
    const [firstSecheduleDate, setFirstSecheduleDate] = useState(null)

    useEffect(()=>{
        if(data){
            setResponseData(data)
            setFetchingData(false)
        }
    },[data])

    useEffect(() => {
        if (selectedLocation) {
            setCurrentMonth(new Date()); // Reset to current month only if selectedLocation changes
            setResponseData(data); // Update response data
            setSelectedDate(null); // Reset selected date
            setExpanded(false); // Collapse expanded state
        }
    }, [selectedLocation]);

    useEffect(() =>{
        if (responseData && responseData.Dates) {
            // Filter dates to include only those in the current month
            const filteredDates = responseData.Dates.filter(day => {
            const [year, month, d] = day.Date.split('-').map(Number);
            
            return (
                year === currentMonth.getFullYear() &&
                month -1 === currentMonth.getMonth()
            );
            });

            if (filteredDates.length === 0) {
                setTimesSlotData({});
                setSelectedDate(null);
                return;
            }

            const mappedData = filteredDates.reduce((acc, day) => {
            const key = new Date(day.Date).toISOString().split('T')[0];
            acc[key] = day.Times;
            return acc;
            }, {});
            setTimesSlotData(mappedData);

            const firstAvailableDate = filteredDates.find(day => {
            const dayDate = new Date(day.Date);
            return (
                day.Times &&
                day.Times.length > 0 &&
                dayDate >= new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 0)
            );
            });
            if (firstAvailableDate) {
                const momentDate = moment(firstAvailableDate.Date);
                setSelectedDate(momentDate.toDate());
                setFirstSecheduleDate(momentDate.toDate());
            }
            else{
                setSelectedDate(null)
            }
        }
    },[responseData])

    useEffect(() => {
        if(selectedDate && currentMonth){
            setDaysInMonth(getDaysInMonth(currentMonth));
        }
    },[selectedDate, currentMonth]);


    const getDaysInMonth =(month) => {
        const year = month.getFullYear()
        const monthIndex = month.getMonth();
        const date = firstSecheduleDate && firstSecheduleDate.getMonth() == monthIndex && firstSecheduleDate.getFullYear() == year ?
         new Date(firstSecheduleDate) : 
         new Date(year, monthIndex, 1)
        const days = []
        while(date.getMonth() === monthIndex){
            if(monthIndex === today.getMonth() && year === today.getFullYear()?date >= new Date():true){
                days.push(new Date(date))
            }
            date.setDate(date.getDate() + 1)
        }
        return days
    }

    const handleMonthChange = (offset) => {
        const newMonth = new Date(currentMonth);
        newMonth.setMonth(currentMonth.getMonth() + offset);

        setCurrentMonth(newMonth);
        const firstDate = new Date(newMonth.getFullYear(), newMonth.getMonth(), 1);
        const lastDate = new Date(newMonth.getFullYear(), newMonth.getMonth() + 1, 0);
        setFetchingData(true)

        getTimesDataOnScroll(
            firstDate.toISOString().split('T')[0],
            lastDate.toISOString().split('T')[0]
        );

        setResponseData(null); 
        setSelectedDate(null);
        setExpanded(false);
    };

    const handleDateClick = (date) => {
        setSelectedDate(date);
        setExpanded(false);
    }

    const isMonthOffset = (month, offset) => {
        const today = new Date();
        const targetMonth = new Date(today);
        targetMonth.setMonth(today.getMonth() + offset);
    
        const givenMonth = month.getMonth();
        const givenYear = month.getFullYear();
    
        return (
            givenMonth === targetMonth.getMonth() &&
            givenYear === targetMonth.getFullYear()
        );
    };
    
    const isCurrentMonth = (month) => isMonthOffset(month, 0);
    const isSixthMonth = (month) => isMonthOffset(month, 6);
    
    const formatTime = (time) => {
        if (!time) return '';
        const [hour, minute] = time.split(':');
        const date = new Date()
        date.setHours(hour)
        date.setMinutes(minute);
        return date.toLocaleTimeString([], { hour: '2-digit', minute:'2-digit'})
    }

    const today = new Date()
    const sixMonthLater = new Date()
    sixMonthLater.setMonth(today.getMonth() + 6)

  return (
    isLoadingNewLocation || fetchingData ? <MobileTimesCompShimUI /> :
    <div className="timeslot-container">
        <div className="month-nav">
            <div
                className={`arrow-container left ${!isCurrentMonth(currentMonth) ? '' : 'disabled'}`}
                onClick={!isCurrentMonth(currentMonth) ? () => handleMonthChange(-1) : null}
            >
                <SVGInline svg={ArrowLeft} className="weekday-arrow" />
            </div>
            <span className="month-title">
                {currentMonth.toLocaleString('default', { month: 'long' })} {currentMonth.getFullYear()}
            </span>
            <div
                className={`arrow-container right ${!isSixthMonth(currentMonth) ? '' : 'disabled'}`}
                onClick={!isSixthMonth(currentMonth) ? () => handleMonthChange(1) : null}
            >
                <SVGInline svg={ArrowRight} className="weekday-arrow" />
            </div>
        </div> 
        <div className="day-scroll">
            {daysInMonth && daysInMonth.map((day) => {
                const dateStr = day.toISOString().split('T')[0]
                const hasSlots = !!timeslotData[dateStr]
                const isSelected = selectedDate && selectedDate.toISOString().split('T')[0] === dateStr;
                return(
                    <div
                        key ={dateStr}
                        className={`day-box ${isSelected ? 'selected': hasSlots? 'has-slots':'no-slots'}`}
                        onClick ={()=>handleDateClick(day)}
                    >
                        <div className="day-label">{day.toLocaleDateString('en-US', { weekday : 'short'})}</div>
                        <div className="date-number">{day.getDate()}</div>
                    </div>
                )
             })}
        </div>
        {data && data.Dates && data.Dates.length > 0 && selectedDate ?
        <div>
            <div className="slots-list">
                {timeslotData[selectedDate.toISOString().split('T')[0]]? (
                    <div className="timeslot-grid">
                        {(expanded
                            ? timeslotData[selectedDate.toISOString().split('T')[0]]
                            : timeslotData[selectedDate.toISOString().split('T')[0]].slice(0, 8)
                        ).map((slot, index) => (
                            <div key={index} className="timeslot" onClick={()=>onProviderTimeClick(provider,selectedDate,slot)}><div className="time">{formatTime(slot.Time)}</div></div>
                        ))}
                    </div>
                ):(
                    <div> No Time Slots available</div>
                )}
                {timeslotData[selectedDate.toISOString().split('T')[0]].length > 8 && !expanded && (
                    <div className="show-more" onClick={() => setExpanded(true)}>
                        <a className='clickable available-times-location-label change'>Show More Availability</a>
                        <SVGInline className='dropdown-arrow' svg={arrowDown} />                 
                    </div>
                )}
                {expanded &&
                    <div className="show-more" onClick={() => setExpanded(false)}>
                        <a className='clickable available-times-location-label change'>Show Less Availability</a>
                        <SVGInline className='dropdown-arrow' svg={arrowUp} />
                    </div>
                }
            </div>
        </div>
        :
        <div className="no-times">There are no available appointments for this month — check other months for more availability.</div>
        }
    </div>
  );
}

export default MobileTimesCompNew;